import { City } from '../../domain/city/entities/city.entity';

export const DEFAULT_BRAND = 'Aprova';

export type BrandSource = Pick<City, 'identidade' | 'emailBranding'>;

/**
 * APR-3501 — marca que fecha o título da aba ("Login - <marca>").
 *
 * O texto é o Nome do sistema da cidade (Admin → Identidade & Marca, campo
 * `emailBranding.systemName`), usado exatamente como cadastrado. Só vale para
 * cidade liberada em `settings.brandedPageTitle`: lista de identidades ou
 * `true` para todas. Fora disso — flag desligado, cidade fora da lista, sem
 * nome ou sem cidade — a marca segue "Aprova".
 */
export function resolveBrandName(
  city: BrandSource | null | undefined,
  enabledFor: boolean | string[] | undefined
): string {
  const systemName = city?.emailBranding?.systemName?.trim();

  if (!city || !systemName) {
    return DEFAULT_BRAND;
  }

  const enabled =
    enabledFor === true ||
    (Array.isArray(enabledFor) && enabledFor.includes(city.identidade));

  return enabled ? systemName : DEFAULT_BRAND;
}
